<template>
  <div class="container">
    <h5 class="alert alert-success center-align ppad">List of projects</h5>
        
      <div class="collection">
        <a href="https://x-techno.web.app/" target="_blank" class="collection-item">
          <span class="badge"><i class="material-icons">check</i></span>
            X-Technologies (Startup Company)
        </a>
        <a href="#!" class="collection-item">
          <span class=" badge"><i class="material-icons">check</i></span>
          Tenant Management System (Private Property Owner)
        </a>
        <a href="#!" class="collection-item">
          <span class="badge"><i class="material-icons">check</i></span>
          Inventory System (ITCK, MOHE)
        </a>
        <a href="#!" class="collection-item"><span class="badge">UNITAR
          </span>Alumni Management System
        </a>
      </div>
       
  </div>
</template>
<script>
export default {
  data(){
    return{
      
    }
  }
}
</script>
<style scoped>
.ppad{
  padding: 1.5%;
}
</style>
